import React from 'react';

const SnackIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <rect
      x="14"
      y="18"
      width="36"
      height="28"
      rx="6"
      fill="#ffe082"
      stroke="#ffb300"
      strokeWidth="2"
    />
    <rect x="20" y="24" width="24" height="16" rx="3" fill="#fff8e1" />
    <rect x="24" y="28" width="16" height="8" rx="2" fill="#ffe0b2" />
    <ellipse cx="32" cy="32" rx="2" ry="1" fill="#ffb300" />
    <ellipse cx="40" cy="36" rx="2" ry="1" fill="#ffb300" />
    <ellipse cx="24" cy="36" rx="2" ry="1" fill="#ffb300" />
  </svg>
);

export default SnackIcon;
